module.exports = __webpack_public_path__ + "static/media/buy-and-sell.d407a3bf.png";